<template>
  <div class="w-8 h-4 bg-[#9333ea] rounded-full" />
</template>
